export default "__VITE_ASSET__SDaxEzDR__"